'use client';
var POPOVER_ERRORS = {
    context: "Компонент Popover не найден в дереве",
    children: "Значение свойства children компонента Popover.Target должно быть элементом или компонентом, который принимает ref. Фрагменты, строки, числа и иные примитивы не поддерживаются."
};

export { POPOVER_ERRORS };
